import React from 'react';
import { LicenseInfo } from '@mui/x-license';
import { createRoot } from 'react-dom/client';
import './index.css';
import * as serviceWorker from './serviceWorker';
import Route from './Route';
LicenseInfo.setLicenseKey(
  '72dc4d050b5f1b7aa93dfd56fda7eeaaTz0xMTUyNjAsRT0xNzgyNjA0Nzk5MDAwLFM9cHJvLExNPXBlcnBldHVhbCxQVj1RMy0yMDI0LEtWPTI='
);

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Route />
  </React.StrictMode>
);

serviceWorker.unregister();
